import { Link } from 'react-router-dom';
import { blogPosts } from '@/mocks/blogIndex';

export default function ArticleSection() {
  const featured = blogPosts[0];
  const rest = blogPosts.slice(1);

  return (
    <section className="relative py-16 md:py-24 bg-background-100 overflow-hidden">
      {/* 顶部过渡渐变条 */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-background-50 to-transparent pointer-events-none" />
      {/* 装饰光晕 */}
      <div className="absolute top-1/4 -right-32 w-[500px] h-[500px] rounded-full bg-primary-100/20 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-1/4 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/25 blur-[100px] pointer-events-none" />

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-12">
          <span className="text-xs font-medium text-foreground-400 uppercase tracking-widest">SEO Articles &amp; Guides</span>
          <h2 className="mt-2 text-3xl md:text-5xl font-heading font-bold text-foreground-900">
            Pandabuy Sheet Editorial
          </h2>
        </div>

        {/* Featured article */}
        <Link
          to={`/blog/${featured.slug}`}
          className="group block rounded-2xl overflow-hidden bg-foreground-900 mb-6 md:mb-8"
        >
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/2 h-52 md:h-auto min-h-[260px] overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="md:w-1/2 p-6 md:p-8 flex flex-col justify-center">
              <span className="inline-block w-fit px-3 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs font-medium mb-4">
                {featured.tag}
              </span>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50 leading-tight">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                {featured.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                <span>{featured.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-500"></span>
                <span>{featured.readTime}</span>
              </div>
              <span className="mt-5 inline-flex items-center gap-1 text-sm text-primary-400 font-medium group-hover:gap-2 transition-all">
                Read article <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </div>
        </Link>

        {/* Article grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {rest.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-primary-600 font-medium">{post.tag}</span>
                <h3 className="mt-1 text-base font-heading font-semibold text-foreground-900 line-clamp-2">
                  {post.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2">
                  {post.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                  <span>{post.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{post.readTime}</span>
                </div>
              </div>
            </Link>
          ))}

          {/* External CTA card */}
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group block rounded-2xl overflow-hidden relative min-h-[320px] cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Trendy%20fashion%20store%20interior%20with%20clothing%20racks%20and%20sneaker%20displays%20warm%20ambient%20lighting%20modern%20retail%20aesthetic%20editorial%20photography%20warm%20cream%20and%20beige%20tones%20clean%20minimalist%20composition%20luxury%20shopping%20experience&width=800&height=500&seq=article-cta-store-v2-2026&orientation=landscape"
              alt="Browse full pandabuy spreadsheet store"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20"></div>
            <div className="absolute top-4 left-4">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                Main Store
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-xl font-heading font-bold text-background-50">
                Browse the Full Store
              </h3>
              <p className="mt-1 text-sm text-background-50/80">
                All categories on kaspreadsheet.com — direct from the source.
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-400 font-medium group-hover:gap-2 transition-all">
                Visit now <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}